// 初期表示
export const PAGE_INIT = "industry/telecom/trade-press/PAGE_INIT";
// データ初期化
export const DATA_CLEAR = "industry/telecom/trade-press/DATA_CLEAR";
